<template>
  <div class="first-bar">
    <div class="card-top">
      <div class="image">
        <ImageContainer
          class="img"
          :src="list[0].image.medium"
          :thumb="list[0].image.thumbnail"
          :alt="list[0].title"
        />
      </div>
      <div class="descr">
        <span class="category">{{ list[0].sub_category.name }}</span>
        <h3 class="title">{{ list[0].title }}</h3>
      </div>

      <div class="data-news">
        <p v-html="changeFirstLetter(list[0].brief)" class="brief"></p>
        <span class="day">{{ handleDate(list[0].pub_date) }}</span>
      </div>
    </div>
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 4)"
        :key="item.id"
        class="grid__item"
      >
        <span class="category">{{ item.sub_category.name }}</span>
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <h3 class="card__title limited-text">{{ item.title }}</h3>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.first-bar {
  width: 100%;
  height: 100%;
  margin: 3.5rem 0;
}
.grid {
  display: flex;
  gap: 1vw;
  width: 90%;
  height: 100%;
  margin: 0 auto;
  padding: 0.5rem 0 2rem 0;
  border-top: 1px solid #292929;
  border-bottom: 1px solid #292929;

  &__item {
    flex: 0 0 25%;
  }
}
.category {
  font-family: Roboto;
  font-weight: 500;
  font-size: 0.88em;
  line-height: 2;
  color: rgba(205, 205, 205, 0.5);
}
.card {
  display: flex;
  gap: 0.5vw;
  &__img {
    flex: 0 0 34%;
    .img {
      border-radius: 0px;
      padding-bottom: 70%;
    }
    :deep() img {
      border-radius: 0px;
    }
  }
  .card__title {
    color: #be1653;
    font-weight: bold;
  }
  &__descr {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .data-news {
    font-size: 0.88em !important;
  }
}
.card-top {
  display: none;
}
@media screen and (max-width: 992px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 2rem;
    &__item {
      grid-column: span 3;
    }
  }
  .card {
    &__title {
      --snup: 4;
      line-height: 1.5;
    }
    &__img {
      flex: 0 0 42%;
      height: 13.5vw;
      .img {
        padding-bottom: 0;
      }
    }
    &__descr {
      .data-news {
        margin-top: 1rem;
        text-align: right;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .card-top {
    display: block;
    width: 90%;
    margin: 0 auto;
    .image {
      .img {
        padding-bottom: 70%;
        border-radius: 0px;
        :deep(img) {
          border-radius: 0px;
        }
      }
    }
    .descr {
      position: relative;
      top: -50px;
      width: 80%;
      color: #121212;
      background: #d8d8d8;
      padding: 10px;
      .category {
        color: #be1653;
      }
    }
    .data-news {
      position: relative;
      top: -30px;
      width: 100%;
      .day {
        text-align: right;
        width: 100%;
        display: block;
        font-size: 0.88em;
        line-height: 16px;
        color: rgba(205, 205, 205, 0.5);
        margin-top: 0.5rem;
      }
    }
  }
  .grid {
    border-top: none;
    &__item {
      grid-column: span 6;
    }
    &__item:nth-child(1) {
      display: none;
    }
  }

  .card {
    gap: 0.5rem;
    &__title {
      --snup: 4;
      line-height: 1.5;
    }
    &__img {
      flex: 0 0 33%;
      height: 23vw;
      .img {
        padding-bottom: 0;
      }
    }
    &__descr {
      justify-content: flex-start;
      .data-news {
        margin-top: 0rem;
      }
    }
  }
}
</style>
